export const constraints = ({
	micDeviceId = null,
	noiseSuppression = true,
	autoGainControl = true,
	echoCancellation = true
}) => {

	let audio = {
		noiseSuppression,
		autoGainControl,
		echoCancellation,
		advanced: []
	};

	if (micDeviceId) {
		audio.advanced.push({ deviceId: micDeviceId });
	}

	if (micDeviceId === false) {
		audio = false;
	}

	return { audio };
};